import { Children, isValidElement } from 'react';

/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 * @see Accordion Button StepIndicator Tabs WorkflowBar
 */
export default function getValidChildren<TProps>(children: React.ReactNode) {
  return Children.toArray(children).filter((child) =>
    isValidElement(child),
  ) as React.ReactElement<TProps>[];
}
